import TStrings from './Questions.i18n';

/**
 * The category custom questions are listed under in the Add Element panel.
 *  A business can override it per question
 */
export const CUSTOM_QUESTION_CATEGORY = 'Custom Questions';

export const QuestionCategories = [
    TStrings.QUESTION_CATEGORY_LOGIN,
    TStrings.QUESTION_CATEGORY_CONTACT_INFO,
    TStrings.QUESTION_CATEGORY_TEXT,
    TStrings.QUESTION_CATEGORY_CHOICE,
    TStrings.QUESTION_CATEGORY_SCHEDULING,
    TStrings.QUESTION_CATEGORY_SELLING,
    TStrings.QUESTION_CATEGORY_DISPLAY,
    TStrings.QUESTION_CATEGORY_LEGAL,
    CUSTOM_QUESTION_CATEGORY,
];

export const ThankYouQuestionCategories = [
    TStrings.QUESTION_CATEGORY_LOGIN,
    TStrings.QUESTION_THANK_YOU_CATEGORY_DISPLAY,
    TStrings.QUESTION_THANK_YOU_CATEGORY_CONFIRMATION,
];

export const PaymentQuestionCategories = [
    TStrings.QUESTION_THANK_YOU_CATEGORY_DISPLAY,
];

export const InvoiceQuestionCategories = [
    TStrings.QUESTION_THANK_YOU_CATEGORY_DISPLAY,
    TStrings.QUESTION_INVOICE_CATEGORY,
];

export enum QuestionType {
    Scheduling = 'scheduling',
    ClassScheduling = 'classscheduling',
    AddOn = 'addon',
    Packages = 'packages',
    YesNo = 'yesno',
    AgreeToTerms = 'agreetoterms',
    Checkboxes = 'checkboxes',
    Dropdown = 'dropdown',
    Radios = 'radios',
    Text = 'text',
    BigText = 'bigtext',
    Date = 'date',
    Location = 'location',
    Display = 'display',
    VideoEmbed = 'videoembed',
    ContactInfo = 'contactinfo',
    Email = 'email',
    Upload = 'upload',
    Phone = 'phone',
    ThankYou = 'thankyou',
    Signature = 'signature',
    Payment = 'payment',
    Hidden = 'hidden',
    ClientAccount = 'clientaccount',
    GiftCertificate = 'giftcertificate',
    InvoiceHeader = 'invoiceheader',
    InvoiceLineItems = 'invoicelineitems',
    InvoiceSummary = 'invoicesummary',
    BillingInfo = 'billinginfo',
    VariablePayment = 'variablepayment',
    Custom = 'custom',
}
